<template>
  <div style="margin: 20px auto;">
    <div v-if="show" style="margin: 20px auto;">
      <QrcodeVue id="dynamicIllustration" :value="value"
        :size="size" level="H" />
      <button @click="downloadSVG" class="green">
        {{ $t(`${translationPath}.downloadQR`) }}</button></div>
      <button @click="backToMain" class="red">{{ $t(`${translationPath}.back`) }}</button>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
  data() {
    return {
      value: '',
      size: 300,
      show: false,
      translationPath: 'QR',
    };
  },
  components: {
    QrcodeVue,
  },
  mounted() {
    const { key } = this.$route.query;
    this.value = `${window.location.origin}/short?id=${key}`;
    this.show = true;
  },
  methods: {
    downloadSVG() {
      let svgContent = document.getElementById('dynamicIllustration');
      // eslint-disable-next-line prefer-destructuring
      svgContent = svgContent.childNodes[0];
      const link = document.createElement('a');
      link.download = 'filename.png';
      link.target = '_blank';
      link.href = svgContent.toDataURL();
      link.click();
    },
    backToMain() {
      this.$router.push({ path: 'HabitsDashboard' });
    },
  },
};
</script>

<style scoped lang="scss">
  div {
    margin: 20px auto;
    text-align: center;
  }
  button {
    border: none;
    color: $font-light-color;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
  }
  .green {
      background-color: #4CAF50; /* Green */
    }
    .red {
      background-color: red; /* Green */
    }
</style>
